import type {Content} from '@/ts/types/dto/interventions-dto';
import type {ExploreLibraryItemDTO} from '@/ts/types/dto/recco/library.dto';

/** One content-band rail entry: exactly one of content/challenge is set. */
export interface BandEntry {
  key: string;
  content?: Content;
  challenge?: ExploreLibraryItemDTO;
}

/**
 * Interleaves the recommended challenges into the content cards: one after every third
 * content card, leftovers appended at the end (IPD-2836: "max 3, mixed in with the
 * other content").
 */
export function buildBandEntries(recommendations: Content[], challenges: ExploreLibraryItemDTO[]): BandEntry[] {
  const pending = [...challenges];
  const entries: BandEntry[] = [];
  const challengeKey = (item: ExploreLibraryItemDTO | undefined): string => {
    // Fall back to the position so two malformed items can't collide on "undefined".
    const id = item?.challenge?.id ?? `index-${entries.length}`;
    return `challenge-${id}`;
  };
  recommendations.forEach((content, index) => {
    entries.push({key: `content-${content.id}`, content});
    if ((index + 1) % 3 === 0 && pending.length > 0) {
      const challenge = pending.shift();
      entries.push({key: challengeKey(challenge), challenge});
    }
  });
  for (const challenge of pending) {
    entries.push({key: challengeKey(challenge), challenge});
  }
  return entries;
}
